module.exports = __webpack_public_path__ + "img/spelning2.dda033ce.jpg";